import {
    GET_FUEL_RECORDS,
    DELETE_FUEL_RECORD,
    SET_RECORD_TO_ONE_FUEL_RECORD,
    GET_ALL_FUEL_RECORDS,
} from '../actions/types';
import {
    getFuelRecordsFromFirebase,
    deleteFuelRecordFromFirebase,
    getAllFuelRecordsFromFirebase,
} from '../helpers/firebase';


export async function getFuelRecords() {
    const records = await getFuelRecordsFromFirebase();

    return {
        type: GET_FUEL_RECORDS,
        payload: records,
    };
}

export function deleteFuelRecord(record) {
    const result = deleteFuelRecordFromFirebase(record);

    return {
        type: DELETE_FUEL_RECORD,
        payload: record.key,
    };
}

export function setRecordToOneFuelRecord(record) {
    return {
        type: SET_RECORD_TO_ONE_FUEL_RECORD,
        payload: record,
    };
}

export async function getAllFuelRecords() {
    const records = await getAllFuelRecordsFromFirebase();

    return {
        type: GET_ALL_FUEL_RECORDS,
        payload: records,
    }
}


// WEBPACK FOOTER //
// ./src/app/actions/fuel_records_actions.js